import { appSync, socketConnected, startListening } from '@betty/toolkit/state';
import { Jackpot } from './jackpots.types';
import { fetchJackpots, setJackpots } from './jackpots.slice';
import { logInfo } from '@betty/toolkit/logging';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchJackpots());
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch }) => {
    const socketConnection = action.payload;

    socketConnection.on('JackpotsUpdated', (data: { jackpots: Jackpot[] }) => {
      logInfo('Jackpots', 'updated', data);

      if (!data) {
        return;
      }

      dispatch(setJackpots(data.jackpots));
    });
  },
});
